import * as React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { css } from "@emotion/react";
import { RadioButtonBlock } from "main/javascripts/components/form/RadioButtonBlock";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { IStyle } from "../../form/RadioButton";

export interface IProps {
  hideLabel?: boolean;
  radioButtonStyle?: keyof IStyle;
}

export const CruiseSorterBlock: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { hideLabel = false, radioButtonStyle = "default" } = props;
  const { t } = useTranslation(["component"]);

  const CruiseSorterOption: { text: string; value: string }[] = [
    { text: t("cruise.sortPriceAsc"), value: "price_cents__asc" },
    { text: t("cruise.sortStaysAsc"), value: "stays__asc" },
    { text: t("cruise.sortDepartureDateAsc"), value: "departure_date__asc" },
    { text: t("cruise.sortPriceDesc"), value: "price_cents__desc" },
    { text: t("cruise.sortStaysDesc"), value: "stays__desc" },
    { text: t("cruise.sortDepartureDateDesc"), value: "departure_date__desc" },
  ];

  const { control, setValue } = useFormContext();
  const fieldName = "sort_by";
  const stringFieldName = "sort_by_string";
  const sortValue = useWatch({
    control,
    name: fieldName,
  });
  const sortStringValue = useWatch({
    control,
    name: stringFieldName,
  });
  const checkedValue = `${sortValue[0].sort_name}__${sortValue[0].order}`;

  useEffect(() => {
    if (!sortStringValue) {
      return;
    }

    const sortData = sortStringValue.split("__");

    if (sortData.length === 2) {
      const [sortName, order] = sortData;
      const sortValues = [
        {
          sort_name: sortName,
          order: order,
        },
      ];
      setValue("sort_by", sortValues);
    }
  }, [sortStringValue]);

  return (
    <div css={blockStyle}>
      <RadioButtonBlock
        namespace="cruise"
        label={
          !hideLabel
            ? {
                namespace: "cruise",
                label: "sortBy",
              }
            : undefined
        }
        checkedValue={checkedValue}
        input={{
          name: stringFieldName,
        }}
        options={CruiseSorterOption}
        styleKey={radioButtonStyle}
        borderColorStyleKey="secondary"
      />
    </div>
  );
};

const blockStyle = css`
  padding: ${space.atom} 0;
`;
